import { VisibleCue } from '../learn_cue.ts';
import { CueRow } from '../learn_cue_row.tsx';

export const rhythmCueTestId = 'rhythm-cue';

// The Ready · Set · Go! row for Rhythm Echo (issue #3519): the shared cue row (learn_cue_row.tsx,
// which began here) under Rhythm Echo's test id. It takes the slack between the notation and the tap
// button on the pattern screen and the calibration screen; nothing is rendered inside it between
// pulses.
// `large` is Sing Rhythm's (issue #3723): with no tap button under it the word has the room to be bigger.
export const RhythmCueRow = ({ cue, large }: { cue?: VisibleCue; large?: boolean }) => (
  <CueRow cue={cue} testId={rhythmCueTestId} large={large} />
);
